import React, { useEffect } from "react";
import "./App.css";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import ModalAdd from "./ModalAdd";
import Repo from "./Utility/Repo";
import { Scrollbars } from "react-custom-scrollbars";
import { FaEdit, FaTrashAlt, FaPlus } from "react-icons/fa";
import ModalEdit from "./ModalEdit";
import ModalDelete from "./ModalDelete";
import { Card } from "react-bootstrap";

function TableForm({ projectId }) {
  const [data, setData] = React.useState([]);
  const [bkData, setBkData] = React.useState([]);
  const [itemsForEdit, setItemsForEdit] = React.useState();
  const [itemsForDelete, setItemsForDelete] = React.useState();
  const [loading, setLoading] = React.useState(true);
  const [searchFields, setSearchFields] = React.useState("0");
  const [argomento, setArgomento] = React.useState("0");

  useEffect(() => {
    setData(bkData);
  }, [searchFields]);

  const [modalShow, setModalShow] = React.useState(false);
  const [modalEditShow, setModalEditShow] = React.useState(false);
  const [modalDeletetShow, setModalDeleteShow] = React.useState(false);
  const [selectParent, setSelectParent] = React.useState("");
  const addItems = (items) => {
    data.push(items);
    setData(data);
    setModalShow(false);
  };

  useEffect(() => {
    setData(bkData);
    if (selectParent.length > 0) {
      const res = bkData.filter((obj) => obj.parent == selectParent);
      setData((prevState) => res);
    } else {
      setData((prevState) => bkData);
    }
  }, [selectParent]);

  const switchArgomenti = (name) => {
    switch (true) {
      case name.includes("SCIS_SCNI") || name.includes("SCNI"):
        return "Divorzio";
      case name.includes("SCIS_ADIE") || name.includes("ADIE"):
        return "Matrimonio";
      case name.includes("UFSCD"):
        return "Ufficiale di stato civile ";
      case name.includes("GDR"):
        return "Gestione dei registri ";
      case name.includes("ADA"):
        return "Atti di nascita";
      case name.includes("ARDA"):
        return "Annotazioni e rettificazione degli atti";
      case name.includes("ADNAR"):
        return "Atti di nascita - adozioni e riconoscimenti ";
      case name.includes("NC"):
        return "Nomi e cognomi ";
      case name.includes("CTCA"):
        return "Capacità della persona - tutela - curatela - amministrazione di sostegno ";
      case name.includes("ADUC"):
        return "Atti di unione civile ";
      case name.includes("ADM"):
        return "Atti di morte ";
      case name.includes("CDIP"):
        return "Cittadinanza e diritto internazionale privato ";
      case name.includes("APRCI"):
        return "Iure sanguinis";
      case name.includes("ACTDAG"):
        return "Atti di cittadinanza - trascrizioni - decreti - accertamenti – giuramenti ";
      case name.includes("TASSC"):
        return "Trascrizione atti e sentenze stranieri e comunitari ";
      case name.includes("CTLCP"):
        return "Convenzioni, traduzioni, legalizzazioni e certificati plurilingue ";
    }
  };

  const options = [
    { value: "SCNI", label: "Divorzio" },
    { value: "ADIE", label: "Matrimonio" },
    { value: "UFSCD", label: "Ufficiale di stato civile " },
    { value: "GDR", label: "Gestione dei registri " },
    { value: "ARDA", label: "Annotazioni e rettificazione degli atti" },
    { value: "ADA", label: "Atti di nascita" },
    { value: "ADNAR", label: "Atti di nascita - adozioni e riconoscimenti " },
    { value: "NC", label: "Nomi e cognomi " },
    {
      value: "CTCA",
      label:
        "Capacità della persona - tutela - curatela - amministrazione di sostegno ",
    },
    { value: "ADUC", label: "Atti di unione civile " },
    { value: "ADM", label: "Atti di morte " },
    { value: "CDIP", label: "Cittadinanza e diritto internazionale privato " },
    {
      value: "APRCI",
      label: "Iure sanguinis",
    },
    {
      value: "ACTDAG",
      label:
        "Atti di cittadinanza - trascrizioni - decreti - accertamenti – giuramenti ",
    },
    {
      value: "TASSC",
      label: "Trascrizione atti e sentenze stranieri e comunitari ",
    },
    {
      value: "CTLCP",
      label:
        "Convenzioni, traduzioni, legalizzazioni e certificati plurilingue ",
    },
  ];

  useEffect(() => {
    var data = JSON.stringify({ projectId: projectId });

    Repo.getAllIntents(data)
      .then((response) => {
        const map1 = response.data.map((x) => {
          var trainingPhrasesTemp = [];
          x.trainingPhrases.map((y) => {
            var risposta = "";
            y.parts.map((a) => {
              risposta += a.text + " ";
            });
            trainingPhrasesTemp.push(risposta);
          });

          var answersTemp = [];
          var chipsTemp = [];

          x.messages.map((y) => {
            switch (y.message) {
              case "suggestions":
                y.suggestions.suggestions.map((items) => {
                  chipsTemp.push(items);
                });

                break;
              case "text":
                y.text.text.map((items) => {
                  answersTemp.push(items);
                });
                break;
            }
          });

          var obbj = {
            parent: switchArgomenti(x.displayName),
            intent: x.displayName,
            phrases: trainingPhrasesTemp,
            answers: answersTemp,
            chips: chipsTemp,
            endConv: x.endInteraction,
            id: x.intentId,
            creator: x.creator,
          };
          return obbj;
        });
        setData(map1.sort((a, b) => (a.intent > b.intent ? 1 : -1)));
        setBkData(map1.sort((a, b) => (a.intent > b.intent ? 1 : -1)));
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const eventSearch = (text) => {
    setData(bkData);

    var tempBkData =
      selectParent && selectParent.length > 0
        ? bkData.filter((obj) => obj.parent == selectParent)
        : bkData;

    if (argomento !== "0") {
      tempBkData = tempBkData.filter((obj) => obj.intent.includes(argomento));
    }

    if (text.length > 0) {
      switch (searchFields) {
        case "1":
          var tempOne = [];

          tempBkData.map((a) => {
            var insertValue = a.phrases.join(" ").includes(text);

            if (insertValue) tempOne.push(a);
          });
          setData((prevState) => tempOne);
          break;

        case "2":
          var tempThree = [];
          tempBkData.map((a) => {
            var insertValue = a.answers.join(" ").includes(text);
            if (insertValue) tempThree.push(a);
          });
          setData((prevState) => tempThree);
          break;

        case "3":
          var tempThree = [];
          tempBkData.map((a) => {
            var insertValue = a.creator.includes(text);
            if (insertValue) tempThree.push(a);
          });
          setData((prevState) => tempThree);
          break;
        default:
          var temp = tempBkData.filter((x) =>
            x.intent.toUpperCase().includes(text.toUpperCase())
          );
          setData((prevState) => temp);
          break;
      }
    } else {
      setData((prevState) => tempBkData);
    }
  };

  const setEditItem = (x) => {
    setModalEditShow(true);
    setItemsForEdit(x);
  };

  const setDeleteItem = (x) => {
    setModalDeleteShow(true);
    setItemsForDelete(x);
  };

  return (
    <div className="mt-3" style={{ paddingRight: "65px" }}>
      <div className="row col-12 mb-5">
        <h1>{projectId}</h1>
      </div>

      <ModalAdd
        pushitems={addItems}
        show={modalShow}
        onHide={() => setModalShow(false)}
        projectId={projectId}
        listIntens={
          data
            ? data.map((x) => {
                return { value: x.intent, label: x.intent };
              })
            : []
        }
      />
      <div className="row px-4 mt-2 mb-4">
        <div className="col-3">
          <Form.Select
            size="lg"
            onChange={(e) => {
              setSearchFields(e.target.value);
            }}
            defaultValue={() => setSearchFields("0")}
            aria-label="Default select example"
          >
            <option value="0">Intent</option>
            <option value="1">Domande</option>
            <option value="2">Risposte</option>
            <option value="3">Autore</option>
          </Form.Select>
        </div>
        <div className="col-4">
          <Form.Select
            size="lg"
            onChange={(e) => {
              setArgomento(e.target.value);
            }}
            defaultValue={() => setSearchFields("0")}
            aria-label="Default select example"
          >
            <option value="0">Tutti gli argomenti</option>
            {options &&
              options.map((opt) => (
                <>
                  <option value={opt.value}>{opt.label}</option>
                </>
              ))}
          </Form.Select>
        </div>
        <div className="col-5">
          <input
            className="form-control form-control-lg "
            type="text"
            placeholder="Cerca"
            onChange={(event) => eventSearch(event.target.value)}
          />
        </div>
      </div>
      <Card style={{ backgroundColor: "transparent", border: "none" }}>
        <Card.Body>
          <div className="row">
            <div
              className="col-10"
              style={{ paddingLeft: "20px", fontSize: "18px" }}
            >
              <b>
                Gli inserimenti e le modifiche apportate saranno visibili dopo
                qualche minuto per l'addestramento dell'agente conversazionale
              </b>
            </div>
            <div className="col-2">
              {" "}
              <Button
                variant="primary"
                size="sm"
                className="ml-5"
                onClick={() => setModalShow(true)}
              >
                <FaPlus style={{ marginBottom: "4px" }} /> Nuovo Intent
              </Button>
            </div>
          </div>
          {/* <Scrollbars
            autoHide
            autoHideTimeout={1000}
            autoHideDuration={200}
            style={{ height: "1000px", marginTop: "20px" }}
            autoHeightMin={0}
            autoHeightMax={200}
            thumbMinSize={30}
            universal={true}
          > */}
          <div className="row shadow p-3 m-2 mt-4 bg-white rounded">
            <table className="table bordered responsive">
              <thead
                style={{
                  position: "sticky",
                  top: "0px",
                  background: "white",
                  zIndex: 10,
                }}
              >
                <tr style={{ fontSize: "20px" }}>
                  <th style={{ width: "25%", paddingBottom: "10px" }}>
                    <i>Domande</i>
                  </th>
                  <th style={{ width: "25%", paddingBottom: "10px" }}>
                    <i>Risposte</i>
                  </th>
                  <th style={{ width: "20%", paddingBottom: "10px" }}>
                    <i>Bottoni</i>
                  </th>
                  <th style={{ width: "10%" }}></th>
                </tr>
              </thead>
              {data &&
                data.map((x, index) => (
                  <tbody key={index}>
                    <tr
                      style={{
                        backgroundColor: "#eeeeee",
                      }}
                    >
                      <td colSpan={4} className="text-center">
                        <h6>Titolo: {x.intent}</h6>
                      </td>
                    </tr>
                    <tr key={index}>
                      <td
                        style={{
                          paddingTop: "15px",
                          paddingBottom: "15px",
                        }}
                      >
                        <Scrollbars
                          style={{ height: "250px" }}
                          autoHeightMin={0}
                          autoHeightMax={200}
                          thumbMinSize={30}
                          universal={true}
                        >
                          {x.phrases.length > 0 ? (
                            <>
                              {x.phrases &&
                                x.phrases.map((y, indexY) => (
                                  <ul
                                    key={indexY}
                                    style={{ paddingRight: "15px" }}
                                  >
                                    <li>{y}</li>
                                  </ul>
                                ))}
                            </>
                          ) : (
                            <>
                              <i>Non ci sono domande!</i>
                            </>
                          )}
                        </Scrollbars>
                      </td>
                      <td
                        style={{
                          paddingTop: "15px",
                          paddingBottom: "15px",
                        }}
                      >
                        <Scrollbars
                          style={{ height: "250px" }}
                          autoHeightMin={0}
                          autoHeightMax={200}
                          thumbMinSize={30}
                          universal={true}
                        >
                          {x.answers.length > 0 ? (
                            <>
                              {x.answers &&
                                x.answers.map((y, indexY) => (
                                  <ul
                                    key={indexY}
                                    style={{ paddingRight: "15px" }}
                                  >
                                    <li>{y}</li>
                                  </ul>
                                ))}
                            </>
                          ) : (
                            <>
                              <i>Non ci sono risposte!</i>
                            </>
                          )}
                        </Scrollbars>
                      </td>

                      <td
                        style={{
                          paddingTop: "15px",
                          paddingBottom: "15px",
                        }}
                      >
                        {x.chips.length > 0 ? (
                          <>
                            {x.chips &&
                              x.chips.map((y, indexY) => (
                                <ul key={indexY}>
                                  <li>{y.title}</li>
                                </ul>
                              ))}
                          </>
                        ) : (
                          <>
                            <i>Non ci sono bottoni!</i>
                          </>
                        )}
                      </td>
                      <td>
                        <div
                          className="col-12"
                          style={{ paddingTop: "15px", textAlign: "center" }}
                        >
                          <h6>
                            Autore: {x.creator ? x.creator : <>Non Definito</>}
                          </h6>
                        </div>
                        <div
                          className="col-12"
                          style={{ paddingTop: "15px", textAlign: "center" }}
                        >
                          <h6>
                            Fine Conversazione: {x.endConv ? <>Si</> : <>No</>}
                          </h6>
                        </div>
                        <Button
                          variant="primary"
                          size="sm"
                          onClick={() => setEditItem(x)}
                          style={{ width: "100%", marginTop: "10%" }}
                        >
                          <FaEdit style={{ marginBottom: "4px" }} /> Modifica
                        </Button>{" "}
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => setDeleteItem(x)}
                          style={{ width: "100%", marginTop: "10%" }}
                        >
                          <FaTrashAlt style={{ marginBottom: "4px" }} /> Elimina
                        </Button>
                      </td>
                    </tr>
                  </tbody>
                ))}
            </table>
          </div>
          {/* </Scrollbars> */}
        </Card.Body>
      </Card>
      <ModalEdit
        itemsForEdit={itemsForEdit}
        show={modalEditShow}
        eventShow={setModalEditShow}
        onHide={() => setModalEditShow(false)}
        projectId={projectId}
      ></ModalEdit>

      <ModalDelete
        itemsForDelete={itemsForDelete}
        show={modalDeletetShow}
        eventShow={setModalDeleteShow}
        onHide={() => setModalDeleteShow(false)}
        projectId={projectId}
      ></ModalDelete>

      {loading && (
        <div className="spinnerClass">
          <Spinner
            animation="grow"
            variant="light"
            style={{ width: "70px", height: "70px" }}
          >
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
    </div>
  );
}

export default TableForm;
